<template>
    <BasicSelect
        v-bind="{ ...props, ...attrs }"
        :items="locales"
    >
        <template
            v-if="currentIcon"
            #prependInner
        >
            <BasicIcon
                :name="currentIcon"
                :inherit-fill="false"
                :size="iconSize"
            />
        </template>
    </BasicSelect>
</template>

<script setup lang="ts">
import BasicIcon from '@atoms/BasicIcon/BasicIcon.vue';
import BasicSelect, {
    type BasicSelectProps,
} from '@atoms/BasicSelect/BasicSelect.vue';

const props = defineProps<Omit<BasicSelectProps, 'items'>>();
const attrs = useAttrs();

const iconSize = '16' as const;

const locales = availableLocales.map(({ code, icon }) => ({
    name: code,
    text: code.toUpperCase(),
    iconSize,
    icon,
}));

const currentIcon = computed(() => {
    return props.modelValue ? `${props.modelValue}-flag` : '';
});
</script>
